import React from 'react';
import { livePlayer, getPlayerExternalLink, playerSitecoreData } from 'components/live-player';
import LeaderboardWidgetFavoriteCell from './leaderboard-widget-favorite-cell';
import { playOffStatuses } from '../../leaderboard/js/enums';
import { LEADERBOARD_WIDGET_SCORECARD_TITLE } from '../../live-player/js/enums';

const LeaderboardWidgetFavoriteRow = ({
    player,
    scoringLeaderboard,
    numberOfCells,
    targetsConfig,
    liveScanner,
    stateFavoriteButton,
}) => {
    let targetUrl = null;

    if (targetsConfig) {
        targetUrl = getPlayerExternalLink(targetsConfig.url, player.id);
    }

    const getIsPlayOff = (playerSD) => {
        if (!playerSD) return false;

        if (playerSD.playOffStatus &&
            playerSD.playOffStatus !== playOffStatuses.NOT_PLAYING
        ) {
            return true;
        }

        return !!(playerSD.suddenDeathStatus &&
            playerSD.suddenDeathStatus !== playOffStatuses.NOT_PLAYING);
    };

    const playerSD = player.sitecoreData || playerSitecoreData;


    const showPlayer = () => {
        if (!targetUrl) {
            livePlayer.show(player.id, LEADERBOARD_WIDGET_SCORECARD_TITLE + playerSD.firstName + ' ' + playerSD.lastName);
        }
    };

    const isPlayOff = getIsPlayOff(playerSD);
    return (
        <a
            className={`leaderboard-widget-favorite__row ${isPlayOff ? 'is-playoff' : ''}`}
            href={targetUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={showPlayer}
        >
            {numberOfCells.map((item) => {
                return (
                    <LeaderboardWidgetFavoriteCell
                        scoringLeaderboard={scoringLeaderboard}
                        key={item.id}
                        state={item.id} player={player}
                        isPlayOff={isPlayOff}
                        liveScanner={liveScanner}
                        stateFavoriteButton={stateFavoriteButton}
                    />
                );
            })}
        </a>
    );
};

export default LeaderboardWidgetFavoriteRow;
